import { render } from 'preact';
import { khoiDongTaiNguyen } from './assets/index.js';
import { App } from './ui/App.js';

// Điểm vào M2: UI Preact + scene three.js + vòng lặp game.
// Luật chơi nằm trong src/core; UI/render chỉ đọc state và gửi lệnh.
// B2: nạp atlas sprite đã bake trước khi dựng scene (fallback: vẽ trực tiếp
// bằng hàm charforge nếu chưa bake — không bao giờ chặn game).
const goc = document.getElementById('app');
if (!goc) {
  throw new Error('Không tìm thấy phần tử #app.');
}
khoiDongTaiNguyen()
  .catch(() => false)
  .finally(() => {
    render(<App />, goc);
  });
